var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "cMain" } },
    [
      _c(
        "div",
        { staticClass: "cafe_newbody" },
        [
          _c("popular-list"),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "mAside" } },
            [
              _c("cafe-notice"),
              _vm._v(" "),
              _c("cafe-support"),
              _vm._v(" "),
              _vm._m(0)
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.hotIssueBanner && _vm.hotIssueBanner.image
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "tiara",
                  rawName: "v-tiara",
                  value: _vm.tiaraObj.banner,
                  expression: "tiaraObj.banner"
                }
              ],
              staticClass: "hot_issue_banner"
            },
            [
              _c(
                "a",
                { attrs: { href: _vm.hotIssueBanner.link, target: "_blank" } },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.hotIssueBanner.image,
                      alt: "인기글 하단 배너",
                      width: "1100"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("cafe-fancafe"),
      _vm._v(" "),
      _c("cafe-category")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cafe_issue" }, [
      _c("div", { staticClass: "wrap_tit" }, [
        _c("h3", { staticClass: "tit_item" }, [_vm._v("실시간 이슈")]),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "tab_issue",
            attrs: { id: "tab_keyword", role: "tablist" }
          },
          [
            _c("li", { staticClass: "on", attrs: { role: "presentation" } }, [
              _c(
                "a",
                {
                  staticClass: "link_tab realtime",
                  attrs: {
                    href: "#none",
                    role: "tab",
                    "aria-controls": "keywordList",
                    "aria-selected": "true"
                  }
                },
                [_vm._v("전체")]
              )
            ]),
            _vm._v(" "),
            _c("li", { attrs: { role: "presentation" } }, [
              _c(
                "a",
                {
                  staticClass: "link_tab sisa",
                  attrs: {
                    href: "#none",
                    role: "tab",
                    "aria-controls": "keywordList",
                    "aria-selected": "false"
                  }
                },
                [_vm._v("뉴스")]
              )
            ]),
            _vm._v(" "),
            _c("li", { attrs: { role: "presentation" } }, [
              _c(
                "a",
                {
                  staticClass: "link_tab entertain",
                  attrs: {
                    href: "#none",
                    role: "tab",
                    "aria-controls": "keywordList",
                    "aria-selected": "false"
                  }
                },
                [_vm._v("연예")]
              )
            ]),
            _vm._v(" "),
            _c("li", { attrs: { role: "presentation" } }, [
              _c(
                "a",
                {
                  staticClass: "link_tab sports",
                  attrs: {
                    href: "#none",
                    role: "tab",
                    "aria-controls": "keywordList",
                    "aria-selected": "false"
                  }
                },
                [_vm._v("스포츠")]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("ol", {
        staticClass: "list_issue",
        attrs: { id: "keywordList", role: "tabpanel" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }